import styled from '@emotion/styled';
import { memo } from 'react';
import {
  footerHeight,
  footerTopMargin,
  layoutMaxWidth,
  layoutPadding,
} from '../layout-styles';
import FooterCompayInfo from './CompanyInfo';
import FooterSiteMaps from './SiteMaps';
import {
  breakpointMedium,
  breakpointSmall,
} from '@/constants/breakpoints';
import { colors } from '@/constants/colors';
import { testIds } from '@/constants/test-ids';

type FooterProps = {
  withoutFooterTopMargin?: boolean,
  backgroundColor?: string,
};

const FooterStyled = styled.footer<{ backgroundColor?: string, withoutFooterTopMargin?: boolean }>`
--footer-top-margin-lg: ${({ withoutFooterTopMargin }) => withoutFooterTopMargin ? '0px' : footerTopMargin};

position: absolute;
bottom: 0;
display: flex;
width: 100%;
height: ${footerHeight};
justify-content: center;
padding-bottom: 64px;
background-color: ${({ backgroundColor = colors.white }) => backgroundColor};
transform: translateY(calc(100% + var(--footer-top-margin-lg)));

@media (max-width: ${breakpointMedium}) {
  position: relative;
  height: auto;
  margin-top: ${({ withoutFooterTopMargin }) =>
    withoutFooterTopMargin
      ? '0'
      : '128px'};
  transform: none;
}

@media (max-width: ${breakpointSmall}) {
  margin-top: ${({ withoutFooterTopMargin }) =>
    withoutFooterTopMargin
      ? '0'
      : '80px'};
}
`;

const FooterWrapDiv = styled.div`
width: 100%;
max-width: ${layoutMaxWidth};
align-items: center;
padding: ${layoutPadding};

@media (max-width: ${breakpointSmall}) {
  padding: 0 20px;
}
`;

const Footer = ({ withoutFooterTopMargin, backgroundColor }: FooterProps) => (
  <FooterStyled
    data-testid={testIds.footer.Footer}
    backgroundColor={backgroundColor}
    withoutFooterTopMargin={withoutFooterTopMargin}
  >
    <FooterWrapDiv>
      <FooterSiteMaps />
      <FooterCompayInfo />
    </FooterWrapDiv>
  </FooterStyled>
);

export default memo(Footer);
